import { Routes } from '@angular/router';
import { PrivatePagesWrapperComponent } from '@infodocs/shared/components/private-pages-wrapper/private-pages-wrapper.component';
import { AuthGuard } from '@infodocs/shared/guards/auth.guard';

export const userRoutes: Routes = [
	{
		path: '',
		canActivate: [AuthGuard],
		component: PrivatePagesWrapperComponent,
		children: [
			{
				path: 'profile',
				loadComponent: () =>
					import('./pages/profile-page/profile-page.component').then(m => m.ProfilePageComponent)
			}
		]
	}
];
